// Recovered compiled webpack factory 1281. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "clearCacheNodeDataForSegmentPath", {
      enumerable: !0,
      get: function () {
        return function e(t, r, o) {
          let i = o.length <= 2,
            [s, l] = o,
            u = (0, a.createRouterCacheKey)(l),
            c = r.parallelRoutes.get(s),
            f = t.parallelRoutes.get(s);
          (f && f !== c) || ((f = new Map(c)), t.parallelRoutes.set(s, f));
          let d = null == c ? void 0 : c.get(u),
            p = f.get(u);
          if (i) {
            (p && p.lazyData && p !== d) ||
              f.set(u, {
                lazyData: null,
                rsc: null,
                prefetchRsc: null,
                head: null,
                prefetchHead: null,
                parallelRoutes: new Map(),
                loading: null,
                navigatedAt: -1,
              });
            return;
          }
          if (!p || !d) {
            p ||
              f.set(u, {
                lazyData: null,
                rsc: null,
                prefetchRsc: null,
                head: null,
                prefetchHead: null,
                parallelRoutes: new Map(),
                loading: null,
                navigatedAt: -1,
              });
            return;
          }
          return (
            p === d &&
              ((p = {
                lazyData: p.lazyData,
                rsc: p.rsc,
                prefetchRsc: p.prefetchRsc,
                head: p.head,
                prefetchHead: p.prefetchHead,
                parallelRoutes: new Map(p.parallelRoutes),
                loading: p.loading,
              }),
              f.set(u, p)),
            e(p, d, (0, n.getNextFlightSegmentPath)(o))
          );
        };
      },
    }));
  let n = r(16378),
    a = r(69190);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
